/* eslint-disable no-console */
import params from "../public/data/params.json"
import JQuery from 'jquery'
let $ = JQuery

//var internalThis = null;

export default class okanMainClass{
    constructor(){
        //this.context=context;

        this.leftMouseButtonDown = false;
        this.mouseX = 0;
        this.mouseY = 0;

        this.UI = null;

        this.jsonData = null;
        this.canvas = null;
        this.context = null;
        this.canvasWidth = 0;
        this.canvasHeight = 0;
        this.canvasTop = 0;
        this.canvasLeft = 0;

        this.stairsData = null;
        this.flatsData = null;

        this.turnImages = [];
        this.currentFrame = 0;
        this.currentStair = null;
        this.imagesPerLevel = 0;
        this.hasJustChanged = false;

        this.selectedBatiment = 0;
        this.selectedAppart = null;
        this.showAppartDetails = false;
        this.zoomLevel = 100;

        this.params = params;
        this.autoRotate = false
        this.allowMoveCanvas = false;
        this.textLeftOffset =0;

        this.arianeLevel = 0;

        this.isLoading = true;
        this.loadPercent = 0;

       // internalThis = this;
    }

    setData(data){
        this.jsonData = data;
    }

    init(){
        this.imagesPerLevel = this.jsonData.AppartsCoords[this.selectedBatiment].framesByLevel;

        this.canvas = $("#batCanvas")[0];
        this.canvasWidth = $("#backgroundDiv")[0].clientWidth * (this.zoomLevel / 100);
        this.canvasHeight = $("#backgroundDiv")[0].clientHeight * (this.zoomLevel / 100);

        this.context = this.canvas.getContext('2d');
        this.context.canvas.width = this.canvasWidth;
        this.context.canvas.height = this.canvasHeight;

        this.stairsData = this.makeStairsData();
        this.flatsData = this.makeFlatsData();

        //var containerDiv = document.getElementById('containerDiv');

        this.canvas.addEventListener("mousemove", (event) => { this.movingMouse(event) });
        this.canvas.addEventListener("touchmove", (event) => { this.movingMouse(event) });
        this.canvas.addEventListener("wheel", (event)=> {this.setZoomLevel(event)});
        document.addEventListener("mousedown", ()=>  {this.setLeftMouseButton(true)});
        this.canvas.addEventListener("touchstart", (event)=>  {this.setLeftMouseButton(true); this.movingMouse(event, true)});
        document.addEventListener("mouseup", ()=> {this.setLeftMouseButton(false)});
        this.canvas.addEventListener("touchend", ()=>  {this.setLeftMouseButton(false)});
        //this.canvas.addEventListener("mouseenter", ()=>  {this.setLeftMouseButton(false)});

        window.addEventListener("resize", ()=> {this.windowresize()} );

        this.windowresize();
        this.imageChange(this.currentFrame);        
    }

    preloader(next=null){
        var start = this.jsonData.AppartsCoords[this.selectedBatiment].fromFrame;
        var end = this.jsonData.AppartsCoords[this.selectedBatiment].toFrame;

        this.currentFrame = start;

        if (next == null)
            this.preloadImages(start);
        else{
            this.loadPercent = next / end;
            if(next> end){
                this.init();
                return;
            }
            else{
                this.preloadImages(next);
            }
        }
    }

    preloadImages(index){
        var image = new Image();
        var image_name = "0000000000000000" + index;
        image_name = image_name.substr(image_name.length - params.imageTurnCounterLength);
        var image_path = "img/turn/" + params.imageTurnPrefix + image_name + ".jpg";        
        image.src = image_path;
        $("#backgroundDiv").css("background", "url("+ image_path +") no-repeat center center");
        this.turnImages.push(image);
        image.onload = this.preloader(++index); 
    }

    setZoomLevel(event){
        var delta = Math.sign(event.deltaY);
        if (delta > 0){
            this.zoomLevel = Math.max(50, this.zoomLevel - params.zoomStep);
        }
        else{
            this.zoomLevel = Math.min(150, this.zoomLevel + params.zoomStep);
        }
        this.imageChange(this.currentFrame);
    }

    setAutoRotate(){
        if(this.autoRotate){
            setTimeout(() => {
                this.changeImage(1);
                this.setAutoRotate();
            }, 800);
        }
    }

    setLeftMouseButton(state){
        this.leftMouseButtonDown = state;
    }

    windowresize(){
        setTimeout(() => {
            this.resize();
            if( $("#backgroundDiv")[0].clientHeight > 0)
                $("#batCanvas").css("top", "-" + $("#backgroundDiv")[0].clientHeight + "px");
            else
                $("#batCanvas").css("top", "-" + $("#backgroundDiv")[0].clientHeight + "px");
            this.imageChange(this.currentFrame,true);       
        }, 50);
        
    }

    resize(){
        this.context.clearRect(0,0,this.canvasWidth,this.canvasHeight);

        if($("#backgroundDiv")[0].clientWidth > 0){
            this.canvasWidth = $("#backgroundDiv")[0].clientWidth * (this.zoomLevel / 100);
            this.canvasHeight = $("#backgroundDiv")[0].clientHeight * (this.zoomLevel / 100);
      
            this.context.canvas.width = this.canvasWidth ;
            this.context.canvas.height = this.canvasHeight ;
    /*
            this.canvasLeft = $("#backgroundDiv")[0].offsetLeft + ($("#backgroundDiv")[0].clientWidth * (1-(this.zoomLevel/100)))/2;
            this.canvasTop = $("#backgroundDiv")[0].offsetTop + ($("#backgroundDiv")[0].clientHeight * (1-(this.zoomLevel/100)))/2;
*/
            var rect = this.canvas.getBoundingClientRect();

            this.canvasLeft = rect.left;
            this.canvasTop = rect.top;

        }
        else{
            this.canvasWidth = $("#containerDiv")[0].clientWidth * (this.zoomLevel / 100);
            this.canvasHeight = $("#containerDiv")[0].clientHeight * (this.zoomLevel / 100);
      
            this.context.canvas.width = this.canvasWidth ;
            this.context.canvas.height = this.canvasHeight ;
    
            this.canvasLeft = ($("#containerDiv")[0].clientWidth * (1-(this.zoomLevel/100)))/2;
            this.canvasTop = ($("#containerDiv")[0].clientHeight * (1-(this.zoomLevel/100)))/2;            
        }
        this.context.clearRect(0,0,this.canvasWidth,this.canvasHeight);
    }

    imageChange(imageNumber, getoverlap = true){
        this.resize();
        this.currentFrame = imageNumber;
        $("#backgroundDiv").css("background", "url("+ this.turnImages[imageNumber].src +") no-repeat center center");
        $("#backgroundDiv").css("background-size", "100% 100% ");
        $("#drawingDiv").css("transform", "scale(" + this.zoomLevel /100 + ")" );
        this.getStairData(imageNumber, getoverlap);
    } 

    changeImage(sens){
        this.currentFrame++ ; // plus simple pour les modulo
        if (sens < 0){
            this.currentFrame--;
            var tmpPos = this.stairsData.find(x=> x.id == this.currentStair).pos
            var stairMultiplier = tmpPos == null ? 0 : tmpPos;
            this.currentFrame = Math.min(this.imagesPerLevel * (stairMultiplier + 1), this.currentFrame);
            if (this.currentFrame % this.imagesPerLevel == 0)
                this.currentFrame += this.imagesPerLevel ; 
        }
        else{
            if (this.currentFrame % this.imagesPerLevel == 0)
                this.currentFrame -= this.imagesPerLevel ;
            this.currentFrame++;
            this.currentFrame = Math.max(1, this.currentFrame);
        }
        this.currentFrame--; // plus simple pour les modulo
        this.imageChange(this.currentFrame);    
    }
    
    getStairData(frameNumber, getoverlap= true){
        this.context.clearRect(0,0,this.canvasWidth,this.canvasHeight);
        var allowedTypes = [];
        this.flatsData.forEach(elem =>{
            if(elem.check)
                allowedTypes.push(elem.ori);
        });
        this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[frameNumber].apparts.forEach(appart => {
            if(allowedTypes.includes(appart.type))
                this.colorize(appart.appartCoords.lignesCoord[0], params.unselectedColor);
        });  
        if(getoverlap)
            this.isOverlappingAppart();   
    }



    movingMouse(event, mobile=false){
        var eventX, eventY;

        eventX = event.clientX == undefined ? event.touches[0].clientX : event.clientX;
        eventY = event.clientY == undefined ? event.touches[0].clientY : event.clientY;        
        if(this.leftMouseButtonDown &&!mobile){
            if(this.allowMoveCanvas){
                $("#containerDiv")[0].style.top = $("#containerDiv")[0].offsetTop - this.mouseY + eventY + "px";
                $("#containerDiv")[0].style.left =  $("#containerDiv")[0].offsetLeft - this.mouseX + eventX + "px";
                this.resize();
            }
            else{
                if(this.hasJustChanged)
                    return;  
                var deltaX = this.mouseX - eventX;
                this.changeImage(deltaX);
                this.hasJustChanged = true;
                setTimeout(() => {
                    this.hasJustChanged = false;
                }, params.changingImageDelay); 

            }
        }
        else
        {
            this.isOverlappingAppart();
        }
        this.mouseX = eventX;
        this.mouseY = eventY;
    }

    clickOnAppart(){
        if (this.selectedAppart != null){
            this.showAppartDetails = true;
            this.arianeLevel = 1;
/*
            setTimeout(() => {
                var detailsDiv = document.getElementById("backgroundDetails");
                detailsDiv.removeEventListener("mousemove", (event) => { this.movingMouse(event) });
                detailsDiv.removeEventListener("touchmove", (event) => { this.movingMouse(event) });
                detailsDiv.removeEventListener("wheel", (event)=> {this.setZoomLevel(event)});
                detailsDiv.removeEventListener("mousedown", ()=>  {this.setLeftMouseButton(true)});    

                detailsDiv.addEventListener("mousemove", (event) => { this.movingMouse(event) });
                detailsDiv.addEventListener("touchmove", (event) => { this.movingMouse(event) });
                detailsDiv.addEventListener("wheel", (event)=> {this.setZoomLevel(event)});
                detailsDiv.addEventListener("mousedown", ()=>  {this.setLeftMouseButton(true)});               
            }, 150);
*/
        }
    }

    isOverlappingAppart(reset=true){
        var x = (this.mouseX - this.canvasLeft )/ this.canvasWidth  ;
        var y = (this.mouseY - this.canvasTop) / this.canvasHeight ;   

        this.context.clearRect(0,0,this.canvasWidth,this.canvasHeight);

        var allowedTypes = [];
        this.flatsData.forEach(elem =>{
            if(elem.check)
                allowedTypes.push(elem.ori);
        });       
        if(reset)
            this.selectedAppart = null;

        if(this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[this.currentFrame].apparts.length > 0){
            this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[this.currentFrame].apparts.forEach(appart => {

                if(allowedTypes.includes(appart.type)){
                    var array = appart.appartCoords.lignesCoord[0];
                    var isinside = this.contains(array, y,x);
            
                    if(isinside){
                        this.selectedAppart = appart;
                        this.colorize(appart.appartCoords.lignesCoord[0], params.selectedColor);
                    }
                    else{
                        this.colorize(appart.appartCoords.lignesCoord[0], params.unselectedColor);
                    }

                    var shadowOffset;
                    var font_size;
                    if (this.canvasWidth < 800){
                        shadowOffset = .002;
                        font_size = '.5em';

                    }
                    else{
                        shadowOffset = .0008;
                        font_size = '.8em';
                    }
                        
                    this.context.beginPath();
                    this.context.fillStyle = "#000";
                    this.context.font =  font_size + ' Comfortaa';
                    this.textLeftOffset = this.context.measureText(appart.appartID).width /2;
                    this.context.fillText(appart.appartID, (appart.appartCoords.center[0] + shadowOffset) * this.canvasWidth - this.textLeftOffset,  (appart.appartCoords.center[1] +shadowOffset) * this.canvasHeight);
                    this.context.fillStyle = "#fff";
                    this.context.fillText(appart.appartID, appart.appartCoords.center[0] * this.canvasWidth - this.textLeftOffset,  appart.appartCoords.center[1] * this.canvasHeight);
                    this.context.closePath();
                }
            });
        }           
    }

    downGradeArianeLevel(buttonIndex){
        while(this.arianeLevel > buttonIndex){
            switch (this.arianeLevel) {
                case 1:
                    this.showAppartDetails = false;
                    this.selectedAppart = null;
                    this.windowresize();
                    break;
            
                default:
                    //console.log('houston, we have a problem')
                    break;
            }
            this.arianeLevel--;
        }
    }

    colorize(points, color){
        this.context.fillStyle = color;
        this.context.beginPath();
        var firstPoint = true;
        points.forEach(point => {
            if (firstPoint){
                this.context.moveTo(point[0]* this.canvasWidth , point[1]* this.canvasHeight ) ;
                firstPoint = false;
            }else{
                this.context.lineTo(point[0]* this.canvasWidth  , point[1]* this.canvasHeight );
            }
        });
        this.context.closePath();
        this.context.fill();
    }

    makeFlatsData(){
        var steps = this.imagesPerLevel;   
        var max = this.jsonData.AppartsCoords[0].toFrame;
        var array = [];
        for(var i =0; i < max; i+= steps){
            var found;
            this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[i].apparts.forEach(appart => {
                found = array.findIndex(x=>x.id == appart.type);
                if(found == -1){
                    var entry = {
                        id: appart.type,
                        ori: appart.type, 
                        name:"",
                        count: 1,
                        check: true
                    }
                    array.push(entry); 
                }
                else{
                    array[found].count++;
                }
            });
        }
        array.forEach(elem =>{
            elem.id = elem.id.substr(1);
        })
        array.sort(this.comparaison2);
        array.forEach(elem =>{
            elem.name = elem.id + " pièces";
        })    
        return array;        
    }

    makeStairsData(){
        var steps = this.imagesPerLevel;   
        var max = this.jsonData.AppartsCoords[this.selectedBatiment].toFrame;

        var array = [];
        var posInArray = 0;

        for(var i =0; i < max; i+= steps){
            var entry = {
                id: null,
                name: "",
                pos: posInArray
            }
            if(this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[i].apparts.length==0){
                entry.name = "Vue d'ensemble";
            }
            else {
                entry.id = this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[i].apparts[0].appartLevel;
                switch (entry.id){
                    case 0:
                        entry.name = "Rez-de-chaussée";
                    break;
                    case 1:
                        entry.name = "1er étage";
                    break;
                    default:
                        entry.name =  entry.id + "ème étage";
                    break;
                }
            }         
            array.push(entry);
            posInArray++;
        }
        array.sort(this.comparaison);
        if(params.flatsOnRoof)
        {
            array[1].name = "Toit";
        }
        return array;
    }

    comparaison(a,b){
        if(b.id == null)
            return 1;
        if(a.id == null)
            return -1;
        return b.id - a.id;
    }   

    comparaison2(a,b){
        if(a.id == null)
            return 1;
        if(b.id == null)
            return -1;
        return a.id - b.id;
    } 
  
    setPopup(){  
        setTimeout(() => {
            if(this.selectedAppart == null)
                return;            
            var popupElement = $('#popup');
            popupElement.css("left", this.canvasLeft - this.textLeftOffset/2 + this.selectedAppart.appartCoords.center[0] * this.canvasWidth - popupElement[0].clientWidth /2) ;
            
            if(this.selectedAppart.appartCoords.center[1] > .5 ){
                popupElement[0].classList.add("beside");
                popupElement.css("top", this.selectedAppart.appartCoords.center[1] * this.canvasHeight - popupElement[0].clientHeight + this.canvasTop - 20 + "px");
            }
            else{
                popupElement[0].classList.remove("beside");
                popupElement.css("top", this.selectedAppart.appartCoords.center[1]* this.canvasHeight + this.canvasTop + 10 + "px" );
            }           
        },50);
    }


    /**
     * @return {boolean} true if (lng, lat) is in bounds
     */
    contains(bounds, lat, lng) {
        //https://rosettacode.org/wiki/Ray-casting_algorithm
        var count = 0;
        for (var b = 0; b < bounds.length; b++) {
            var vertex1 = bounds[b];
            var vertex2 = bounds[(b + 1) % bounds.length];
            if (this.west(vertex1, vertex2, lng, lat))
                ++count;
        }
        return count % 2;
    }

    /**
     * @return {boolean} true if (x,y) is west of the line segment connecting A and B
     */
    west(A, B, x, y) {
        if (A[1] <= B[1]) {
            if (y <= A[1] || y > B[1] ||
                x >= A[0] && x >= B[0]) {
                return false;
            } else if (x < A[0] && x < B[0]) {
                return true;
            } else {
                return (y - A[1]) / (x - A[0]) > (B[1] - A[1]) / (B[0] - A[0]);
            }
        } else {
            return this.west(B, A, x, y);
        }
    }

    log(title,value){
        console.log(title,value);
    }

}